const cookiePrefix = {
  uid: 'uid_REFERRAL_MICROSITE_',
  token: 'tokenMFA_REFERRAL_MICROSITE_',
  identifier: 'identifier_REFERRAL_MICROSITE_',
  trustDevice: 'trustDevice_REFERRAL_MICROSITE_',
};

const UID_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year
const TRUST_MAX_AGE_SECONDS = 60 * 60 * 24 * 90; // 90 days
const SESSION_MAX_AGE_SECONDS = 60 * 5; // 5 minutes

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
}

function writeCookie(name, value, maxAgeSeconds) {
  if (typeof document === 'undefined') return;
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    'path=/',
    'SameSite=Lax',
  ];
  if (window.location?.protocol === 'https:') {
    parts.push('Secure');
  }
  if (maxAgeSeconds != null) {
    parts.push(`Max-Age=${maxAgeSeconds}`);
  }
  document.cookie = parts.join('; ');
}

function deleteCookie(name) {
  writeCookie(name, '', 0);
}

function uuidV4() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback when crypto.randomUUID is unavailable
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.trunc(Math.random() * 16);
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateUid(username) {
  const key = cookiePrefix.uid + username;
  const existing = readCookie(key);
  if (existing) return existing;
  const uid = uuidV4();
  writeCookie(key, uid, UID_MAX_AGE_SECONDS);
  return uid;
}

export function getMfaCookies(username) {
  return {
    uid: readCookie(cookiePrefix.uid + username),
    token: readCookie(cookiePrefix.token + username),
    identifier: readCookie(cookiePrefix.identifier + username),
    trustDevice: readCookie(cookiePrefix.trustDevice + username) === 'true',
  };
}

export function setMfaCookies(username, { token, identifier, trustDevice }) {
  const maxAge = trustDevice ? TRUST_MAX_AGE_SECONDS : SESSION_MAX_AGE_SECONDS;
  writeCookie(cookiePrefix.token + username, token, maxAge);
  if (identifier != null) {
    writeCookie(cookiePrefix.identifier + username, identifier, maxAge);
  }
  writeCookie(cookiePrefix.trustDevice + username, trustDevice ? 'true' : 'false', maxAge);
}

export function clearMfaCookies(username) {
  deleteCookie(cookiePrefix.token + username);
  deleteCookie(cookiePrefix.identifier + username);
  deleteCookie(cookiePrefix.trustDevice + username);
}

export function clearUidCookie(username) {
  deleteCookie(cookiePrefix.uid + username);
}
